import {Directive, ElementRef, effect, inject, OnInit, input} from "@angular/core"

@Directive({
    selector: "[cmIsLoading]",
})
export class IsLoadingDirective implements OnInit {
    readonly $cmIsLoading = input(false, {alias: "cmIsLoading"})

    private readonly elementRef = inject(ElementRef)

    constructor() {
        effect(() => {
            this.elementRef.nativeElement?.classList?.toggle("cm-loading-placeholder--loading", this.$cmIsLoading())
        })
    }

    ngOnInit() {
        this.elementRef.nativeElement?.classList?.add("cm-loading-placeholder")
    }
}
